import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white time-duration-box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body letter-spacing\"><div class=\"icon position-relative lh-1 text-primary\"><i class=\"flaticon-copy\"></i></div><div class=\"content\"><span class=\"d-block fw-bold text-dark-emphasis mb-1\"> Average Speed Of Answer </span><h2 class=\"mb-0 fw-black\">1 min 12s</h2></div><p class=\"mb-0 fw-medium\"> Measure how quickly support staff answer incoming calls. </p></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}